export default __webpack_public_path__ + "static/media/baseline-battery_50-24px.6d743475.svg";